<template>
  <div id="page-accessibility">
    <v-container>
      <h1>{{ $t("Accessibility page") }}</h1>
      <div v-html="$t('Accessibility content')"></div>
    </v-container>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$i18n.t("Accessibility page")
    };
  },
  name: "Accessibility",
  mounted() {
    const u = "support";
    const d = "linagora.com";
    // Select all links with class "ml1"
    const links = document.querySelectorAll(".ml1");
    links.forEach(link => {
      link.href = `mailto:${u}@${d}`;
      link.innerText = `${u}@${d}`;
    });
  }
};
</script>

<style lang="stylus" scoped></style>
